import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import api from '../../../services/api.js';

export default function TableConsultores() {
    const snack = useRef()
    const tableRef = useRef();
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [calls, setCalls] = useState([]);

    const state = {
        columns: [
            { title: "Nome", field: "contact_name" }, //funcionário
            { title: "Data e Hora", field: "start_time" }, //data e hora da ligação
            { title: "Duração da Chamada", field: "duration" }, //duração da chamada
            { title: "Pergunta Realizada", field: "question_num" }, //pergunta feita
            { title: "Status da Ligação", field: "call_status" }, //se o funcionário atendeu completed ou no-answer
            { title: "Resposta do Usuário", field: "user_resp" }, //acertou a pergunta
            { title: "Número Chamado", field: "to" }, // numero cadastrado no momento da chamada
            { title: "Ligação Processada", field: "processed" }, // se for ou não processada
            { title: "ControlId", field: "_id" }, //acertou a pergunta
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/calls`)
                .then((res) => {
                    for (let call of res.data) {
                        call['start_time'] = new Date(call['start_time']).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })
                        call['contact_name'] = call.user.nome
                        call['processed'] = call['info_updated'] ? "Sim" : "Não"
                    }
                    setCalls(res.data)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar informações das ligações", { variant: 'error' })
                });
        }
        fetchData();
    }, []);

    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Sistema de verificação de disponibilidade de usuários"
                columns={state.columns}
                data={calls}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20, calls.length],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
            />
        </Container >
    );
}
